import { CustomValidator } from "../../common/validation/types";
import { isValidCuitCuil } from "../../common/validation/cuit";
import { TenantProfileValuesType } from "./TenantProfileCommonStore";

/**
 * Validación matemática del CUIT/CUIL (dígito verificador, módulo 11 AFIP) de
 * taxId. Espejo del server (validateTenantProfileCuitFields): el server es la
 * autoridad, esto es UX. Solo valida el campo con valor.
 */
export const tenantProfileCuitCheckDigitValidator: CustomValidator<TenantProfileValuesType> = {
  name: "tenantProfileCuitCheckDigitValidator",
  validate(values, langStore) {
    const errors: Record<string, { message: string; fieldLabel: string }> = {};
    const cardErrors: Record<string, string[]> = {};

    if (values.taxId?.trim() && !isValidCuitCuil(values.taxId)) {
      errors.taxId = {
        message: langStore.cuitCheckDigitInvalid,
        fieldLabel: langStore.TenantProfileTaxIdLabel,
      };
    }

    return { errors, cardErrors };
  },
};
